export default [
  {
    name: 'Admin.Managers',
    path: 'managers',
    component: () => import('./components/managers/List')
  },
  {
    name: 'Admin.Managers.Edit',
    path: 'managers/:id?/edit',
    props: true,
    component: () => import('./components/managers/Edit')
  },
  {
    name: 'Admin.ManCompanies',
    path: 'mancompanies',
    component: () => import('./components/man-companies/List')
  },
  {
    name: 'Admin.ManCompanies.Edit',
    path: 'mancompanies/:id?/edit',
    props: true,
    component: () => import('./components/man-companies/Edit')
  },
  {
    name: 'Admin.Users',
    path: 'users',
    component: () => import('./components/users/List')
  },
  {
    name: 'Admin.Users.Edit',
    path: 'users/:id?/edit',
    props: true,
    component: () => import('./components/users/Edit')
  },
  {
    name: 'Admin.Offices',
    path: 'offices',
    component: () => import('./components/offices/List')
  },
  {
    name: 'Admin.Offices.Edit',
    path: 'offices/:id?/edit',
    props: true,
    component: () => import('./components/offices/Edit')
  },
  // TODO: лучше не делать такие глупости,
  // а отдавать 404, тк страница не существует
  {
    name: 'Admin.Offices.Departments',
    path: 'offices/:id/departments',
    redirect: { name: 'Admin.Offices.Edit' }
  },
  {
    name: 'Admin.Offices.Departments.Edit',
    path: 'offices/:id/departments/:departmentId?/edit',
    props: true,
    component: () => import('./components/offices/departments/Edit')
  },
  {
    name: 'Admin.Steps',
    path: 'steps',
    component: () => import('./components/steps/List')
  },
  {
    name: 'Admin.Steps.Edit',
    path: 'steps/:id?/edit',
    props: true,
    component: () => import('./components/steps/Edit')
  },
  {
    name: 'Admin.Cameras.List',
    path: 'cameras',
    component: () => import('./components/cameras/List')
  },
  {
    name: 'Admin.Cameras.Edit',
    path: 'cameras/:id?/edit',
    props: true,
    component: () => import('./components/cameras/Edit')
  }
]
